import React, { useState, useEffect } from "react";
import { Button, Stack, useTheme } from "@mui/material";

const PromotionMenu = ({
  priceTable,
  selectedStartTime,
  handleSelectPriceTableIndex,
  isTimeReserved,
}) => {
  const [selectedPromotionIndex, setSelectedPromotionIndex] = useState(-1);
  const theme = useTheme();

  useEffect(() => {
    // Reset selected index on start time change
    setSelectedPromotionIndex(-1);
    handleSelectPriceTableIndex(-1);
  }, [selectedStartTime]);

  const addHours = (date, hours) => {
    const newDate = new Date(date);
    const floorHours = Math.floor(hours);
    const minutes = (hours - floorHours) * 60;

    newDate.setHours(newDate.getHours() + floorHours);
    newDate.setMinutes(newDate.getMinutes() + minutes);
    return newDate;
  };

  const handleSelectPromotion = (index) => {
    handleSelectPriceTableIndex(index);
    setSelectedPromotionIndex(index);
  };

  return (
    <Stack direction="column" spacing={1}>
      {selectedStartTime == null
        ? null
        : priceTable.Hour?.map((hourItem, index) => {
            const Hour = priceTable.Hour[index];
            const FreeHour = priceTable.FreeHour[index];
            const Price = priceTable.Price[index];
            const Discount = priceTable.Discount[index];
            const totalHour = 
              addHours(
                new Date(selectedStartTime),
                Hour + FreeHour
              )

            const isDisabled = isTimeReserved(totalHour, "promo");
            const buttonText = `${Hour + FreeHour}小時${
              FreeHour !== 0 ? `(含贈${FreeHour})` : ""
            } $${Price - Discount}`;
            const displayText = isDisabled
              ? `${buttonText}(已預定)`
              : buttonText;

            return (
              <Button
                key={index}
                variant="contained"
                disabled={isDisabled}
                onClick={() => handleSelectPromotion(index)}
                sx={
                  selectedPromotionIndex === index
                    ? {
                        fontSize: "12pt",
                        border: 4,
                        borderRadius: 1,
                        borderColor: theme.palette.text.blue,
                        color: theme.palette.text.blue,
                        fontWeight: "bold",
                      }
                    : {
                        fontSize: "12pt",
                      }
                }
              >
                {displayText}
              </Button>
            );
          })}
    </Stack>
  );
};

export default PromotionMenu;
